import React, { useState } from 'react';
import Public from 'Public';
import Private from 'Private';
import { useAuth } from 'modules/auth/hooks';
import ErrorBoundary from 'partial/containers/ErrorBoundary';
import { ModalProvider } from 'partial/components/Modal';
import { QueryClient, QueryClientProvider } from 'react-query';
import { ReactQueryDevtools } from 'react-query/devtools';
import Helmet from 'react-helmet';

function App() {
  const [queryClient] = useState(() => new QueryClient());
  const [isAppReady, isAuthenticated] = useAuth();
  if (!isAppReady) return null;
  return (
    <QueryClientProvider client={queryClient}>
      <ErrorBoundary>
        <ModalProvider>
          <Helmet>
            <title>eMessage - Admin</title>
          </Helmet>
          {isAuthenticated ? <Private /> : <Public />}
        </ModalProvider>
      </ErrorBoundary>
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  );
}

export default App;
